<template>
  <div class="main-content">
    <cargo-up-down-resize
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column',paddingTop:'5px'}"
      style="height: 100%"
    >
      <template slot="up">
        <div v-show="isEdit" class="section">
          <div>
            <el-button no="AddTickets" type="primary" @click="pm.addSlaveHandler()">{{ $t('SeaExport.AddTickets') }}</el-button>
            <el-button no="RemoveTickets" type="danger" @click="pm.removeSlaveHandler()">{{ $t('SeaExport.RemoveTickets') }}</el-button>
          </div>
        </div>
        <div class="section" style="flex: 1">
          <cargo-ag-grid
            no="upGrid"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="lclSlaves"
            style="width:100%;height:100%"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div style="padding:5px 0">
          <div style="float:left">
            <el-button v-show="readonly && showSplitButton && viewSource!='salesDetail'" no="splitClickEventHandler" type="primary" @click="pm.splitClickEventHandler()">{{ $t('SeaExport.SplitHbl') }}</el-button>
            <el-button v-show="isEdit" no="GetContainerNo" type="primary">{{ $t('SeaExport.GetContainerNo') }}</el-button>
            <el-button v-show="isEdit" no="changeSealHandler" type="primary" @click="changeSealHandler">{{ $t('SeaExport.SealNoChangeAdfterInspection') }}</el-button>
            <el-button v-show="isEdit" no="addToContainerHandler" type="info" plain style="color:green" @click="pm.addToContainerHandler()">↓</el-button>
            <el-button v-show="isEdit" no="removeToContainerHandler" type="info" plain style="color:red" @click="pm.removeToContainerHandler()">↑</el-button>
          </div>
          <div style="float:right">
            <el-form :inline="true" label-width="55px" label-position="left">
              <el-form-item :label="totalLabel.package" class="auto-width">
                <el-input v-model="slaveTotalDesc.slaveTotalQuantity" no="slaveTotalQuantity" style="width:100px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalWeight')" class="auto-width">
                <el-input v-model="slaveTotalDesc.slaveTotalWeight" no="slaveTotalWeight" style="width:100px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalCubage')" class="auto-width">
                <el-input v-model="slaveTotalDesc.slaveTotalCubage" no="slaveTotalCubage" style="width:100px" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template slot="down">
        <cargo-left-right-resize
          :left-style="{display: 'flex', flexDirection: 'column',width:'20%'}"
          :right-style="{display: 'flex', flexDirection: 'column',width:'80%'}"
          style="height: 100%;min-height: 300px"
        >
          <template slot="left">
            <div class="section" style="flex: 1">
              <cargo-ag-grid
                no="leftGrid"
                :grid-options="left.gridOptions"
                :column-defs="containerColumnDefs"
                :row-data="containers"
                style="height:100%"
                @gridReady="params=>{left.gridApi=params.api}"
              />
            </div>
          </template>
          <template
            slot="right"
          >
            <div class="section" style="flex: 1;">
              <cargo-ag-grid
                slot="right"
                no="rightGrid"
                :grid-options="right.gridOptions"
                :column-defs="usageColumnDefs"
                :row-data="selectedContainer.containerUsage"
                style="flex-grow:1"
                @gridReady="params=>{right.gridApi=params.api}"
              />
            </div>
            <div style="padding:5px 0">
              <div style="float:left">
                <span>{{ usagesTotalDesc.txtNum }}</span>
              </div>
              <div style="float:right">
                <el-form :inline="true" label-width="55px" label-position="left">
                  <el-form-item :label="totalLabel.package" class="auto-width">
                    <el-input v-model="usagesTotalDesc.usageTotalQuantity" no="usageTotalQuantity" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.weight" class="auto-width">
                    <el-input v-model="usagesTotalDesc.usageTotalWeight" no="usageTotalWeight" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.cubage" class="auto-width">
                    <el-input v-model="usagesTotalDesc.usageTotalCubage" no="usageTotalCubage" style="width:100px" />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-up-down-resize>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainer"
      @sealCloseHandler="sealCloseHandler"
    />

    <!-- 加入拼箱工作单查询弹窗 -->
    <query-re-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="job"
      @callback="rows=>{pm.slaveAddedHandler(rows)}"
    />

  </div>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import queryReLclDialog from '../queryRELclDialog'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { TabLclContainerBase } from './tabLclContainerBase'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import SealNumberChangeDialog from '@/components/Cargo/Job/sealNumberChangeDialog'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { Job } from '@/class/model/booking/Job'
import { Container } from '@/class/model/booking/Container'
import { sortByMultiField } from '@/utils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import { roundHalfUp } from '@/utils/NumberUtils'

export default {
  name: 'ReTabLclContainer',
  components: { SealNumberChangeDialog, cargoUpDownResize, cargoLeftRightResize, queryReLclDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    // 显示拆分主票按钮
    showSplitButton: {
      type: Boolean,
      required: false,
      default: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      default: ''
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    location: { // 日志【模块位置】,【数据更新日志】使用
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pm: new TabLclContainerBase(this),
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        suppressContextMenu: true,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.getRenderedNodes()
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: this.$t('RailwayExport.mbl'),
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('RailwayExport.transitStation'),
          field: 'transitStation',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('RailwayExport.destinationStation'),
          field: 'destinationStation',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('RailwayExport.ETD'),
          field: 'etd',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PackageType'),
          field: 'packing',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveQuantityLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveWeightLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveCubageLabelFunc(params.data)
          }
        }
      ],
      selectedNode: null,
      gridApi: null,
      left: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocusedContainer(event)
          },
          onRowClicked: this.containerChangeHandler
        },
        gridApi: null
      },
      right: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true, // 如果为true，则不能选择单元格
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
          context: {
            componentParent: this
          }
        },
        gridApi: null
      },
      boxNoDialog: {
        visible: false
      },
      querySELclDialog: {
        visible: false
      },
      containerUsageColl: [], // 装箱信息
      selectedContainer: new Container().fillDefaultValue().getData(), // 选中的箱子
      job: new Job().fillDefaultValue().getData(),
      containers: [], // 箱子列表
      lclSlaves: [],
      slaveTotalDesc: { // 合计汇总
        slaveTotalQuantity: '',
        slaveTotalWeight: '',
        slaveTotalCubage: ''
      },
      usagesTotalDesc: { // 合计汇总
        txtNum: '',
        usageTotalQuantity: '',
        usageTotalWeight: '',
        usageTotalCubage: ''
      },
      totalLabel: { // 合计汇总label
        package: this.$t('SeaExport.TotalNumberOfPackages') + ':',
        weight: this.$t('SeaExport.TotalWeight') + ':',
        cubage: this.$t('SeaExport.TotalCubage') + ':'
      },
      operationTipsAarry: [] // 记录修改的 operationTips
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    selectedSlave() {
      return this.selectedNode ? this.selectedNode.data : {}
    },
    containerColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: true,
              isTrim: true,
              classFunc: (params) => {
                return this.containerNbrStyleFunction(params.data)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            },
            multiplePaste: { isUppercase: true, isTrim: true, maxLength: 11 }
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: true,
              isTrim: true
            },
            valueChanged: p => { this.containerItemEditEndHandler(p) },
            multiplePaste: { isUppercase: true, isTrim: true }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            precision: 3,
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            },
            multiplePaste: { isNumber: true, precision: 2 }
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          hide: true,
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'quantity') },
              textConverter: (val) => {
                return !val ? '' : ColumnUtils.numberColumnLabelFunc(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          hide: true,
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'weight') },
              textConverter: (val) => {
                return !val ? '' : ColumnUtils.number3ColumnLabelFunc(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          hide: true,
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'cubage') },
              textConverter: (val) => {
                return !val ? '' : ColumnUtils.number3ColumnLabelFunc(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Inspection'),
          field: 'inSpected',
          width: 120,
          cellRenderer: (params) => {
            return this.subInSpectedLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.ApproachDate'),
          field: 'approachDate',
          hide: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PlayDate'),
          field: 'playDate',
          hide: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.LoadingPort'),
          field: 'loadingPort',
          hide: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'destinationPort',
          hide: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TheArrivalOfPacketsSent'),
          field: 'transportMessageDate',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsClearanceInfo'),
          field: 'customReleaseDate',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.releaseDateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.WharfReleaseInfo'),
          field: 'wharfReleaseDate',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.releaseDateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerAscription'),
          field: 'containerAscription',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'chineseName',
              value: 'code'
            },
            attrs: {
              cellSelectAttrs: { fullOptionsCBFunc: () => [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE] }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'plateNumber',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.plateApproachDate'),
          field: 'plateApproachDate',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.platePlayDate'),
          field: 'platePlayDate',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            },
            multiplePaste: {}
          }
        }
      ]

      return columnDefs
    },
    usageColumnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'serialNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: this.isEdit ? 'el-input-number' : 'span',
            precision: 0,
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 0 }
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: this.$t('RailwayExport.mbl'),
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('RailwayExport.transitStation'),
          field: 'transitStation',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('RailwayExport.destinationStation'),
          field: 'destinationStation',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('RailwayExport.ETD'),
          field: 'etd',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoName',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('SeaExport.Soc'),
          field: 'soc',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: 'HSCODE',
          field: 'hsCode',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'quantity')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 0 }
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'weight')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'cubage')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.OperationTips'),
          field: 'operationTips',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: {}
          }
        }
      ]
      return columnDefs
    }
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }

      this.operationTipsArray = []

      const job = row
      // 复制，拆分 动作 无uuid
      if (row.uuid) {
        this.job = job
        if (!job.containers) {
          job.containers = []
        }
        this.containers = job.containers
        this.lclSlaves = this.job.lclSlaves
      } else {
        row.seaEQ = []
        row.lclSlaves = []
        row.containers = []
      }

      this.pm.commitProperties()
    },
    // 保存数据提交
    getSubmitData() {
      this.pm.validateForm()

      // operationTips 数据处理(设置更新标识)
      for (const container of this.job.containers) {
        for (const usage of container.containerUsage) {
          const index = this.operationTipsArray.findIndex(p => p.jobUuid === usage.jobUuid)
          if (index > -1) {
            usage.operationTipsDirty = true
          }
        }
      }

      // 重新组装数据 过滤 container.containerUsages isDirty=true 至后端保存
      return {
        containers: this.job.containers, // .filter(p => p.isDirty === true),
        delContainerUuids: this.job.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.job.delContainerUsageUuids // 删除的装箱uuid
      }
    },

    // 箱子列编辑
    containerItemEditEndHandler(params) {
      params.data.isDirty = true // 用于校验数据是否修改标识
      if (params.field === 'sealNo') {
        params.data.isReSealed = true // 此属性赋值未用上
      }
      if (params.field === 'containerWeight') {
        // 箱重处理四舍五入 入库（控件只做了前端显示处理）
        if (params.data.containerWeight) {
          params.data.containerWeight = roundHalfUp(params.data.containerWeight, 2)
        } else {
          params.data.containerWeight = 0
        }
      }
    },
    // 列编辑修改事件 (usageItemEditEndHandler)
    onCellChange(params) {
      const usage = params.data
      if (!usage) {
        return
      }

      // 同步更新container的 usage
      for (const item of this.job.containers) {
        let bFlag = false
        for (const itemUsage of item.containerUsage) {
          if (itemUsage === usage) {
            item.isDirty = true
            bFlag = true
            break
          }
        }
        if (bFlag) {
          break
        }
      }
      usage.isDirty = true // 用于校验数据是否修改标识

      // 排序
      if (params.field === 'serialNo') {
        sortByMultiField(this.selectedContainer.containerUsage, ['serialNo'], false)
      }

      // operationTips 是 job 上的信息
      if (params.field === 'operationTips') {
        const slave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
        if (slave) {
          slave.operationTips = params.data.operationTips
        }
        for (const container of this.job.containers) {
          for (const item of container.containerUsage) {
            if (item.jobUuid === usage.jobUuid) {
              item.operationTips = slave.operationTips
            }
          }
        }

        // 记录 需要修改的operationTips
        const operationTipsObj = this.operationTipsArray.find(p => p.jobUuid === usage.jobUuid)
        if (!operationTipsObj) {
          const obj = { jobUuid: usage.jobUuid, operationTips: usage.operationTips }
          this.operationTipsArray.push(obj)
        } else {
          operationTipsObj.operationTips = usage.operationTips
        }
      }

      // 装箱件毛体刷新至箱子上 件毛体合计 刷新至箱子上  h5 新增需求，cargo 中无此功能
      if (params.field === 'quantity' || params.field === 'weight' || params.field === 'cubage') {
        this.pm.refreshContainerQwc()
      }

      this.pm.refreshSalves()
    },
    // 验更改封号
    changeSealHandler() {
      if (!this.selectedContainer) { return }
      this.boxNoDialog.visible = true
    },
    // 查验更改封号 回调事件
    sealCloseHandler(data) {
      const container = this.selectedContainer
      if (container.sealNo !== data.sealNo) {
        container.isReSealed = true
        container.inSpected = true
      }
      container.sealNo = data.sealNo
      container.containerNo = data.containerNo
      container.remark = data.remark
      container.isDirty = true
      this.left.gridApi.refreshCells({ force: true })
    },
    containerNbrStyleFunction(container) {
      if (container) {
        if (!ContainerNoHelper.checkContainerNo(container.containerNo)) {
          return 'data-red'
        }
        if (DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), container.containerNo, container.uuid)) {
          return 'data-blue'
        }
      }
      return ''
    },
    slaveQuantityLabelFunc(data) {
      const slaveClass = new Job(data)
      return slaveClass.getUnboxedQuantity()
    },
    slaveWeightLabelFunc(data) {
      const slaveClass = new Job(data)
      return NumberUtils.formatNumber(slaveClass.getUnboxedWeight(), 3)
    },
    slaveCubageLabelFunc(data) {
      const slaveClass = new Job(data)
      return NumberUtils.formatNumber(slaveClass.getUnboxedCubage(), 3)
    },
    containerAscriptionFunc(val) {
      for (const item of SeaExportConstants.CONTAINER_ASCRIPTION_TYPE) {
        if (item.code === val) {
          return item.chineseName
        }
      }
    },
    /**
     * 放行信息转换
     */
    releaseDateLabelFunc(data, fieldName) {
      if (data != null) {
        const value = data[fieldName]
        if (value != null) {
          return 'Y(' + ColumnUtils.dateLabelFunc(value) + ')'
        }
      }
      return 'N'
    },
    subInSpectedLabelFunc(data) {
      if (data) {
        const isInSpected = data.inSpected
        return isInSpected ? this.$t('Message.Yes') : this.$t('Message.No')
      }
      return ''
    },
    containerChangeHandler(event) {
      this.pm.containerChangeHandler(event)
    },
    onCellFocusedContainer(event) {
      if (this.left.gridOptions.api && event.column) {
        this.left.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainer = node.data
          }
        })
      }
    },
    // 组装打印参数
    getPrintData() {
      if (this.job && this.job.masterFlag) {
        const containers = this.left.gridApi.getSelectedRows()
        const params = {}
        if (containers.length === 0) {
          this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
          return
        }
        if (containers.length === 1) {
          const container = new Container(containers[0])
          params.CONTAINER_UUID = container.uuid
          params.jobuuid = this.job ? this.job.uuid : ''
          params.category = 'LCL_RE'
          params.ctx = new RailwayExportJob(this.job)
          // TemplateSelectorWin.getInstance().showThisWin(job, "LCL", params, this);
        } else {
          params.CONTAINER_UUID = Array.from(containers, p => p.uuid)
          params.jobuuid = this.job ? this.job.uuid : ''
          params.category = 'CONTAINER_LIST_RE'
          params.ctx = new RailwayExportJob(this.job)
          // TemplateSelectorWin.getInstance().showThisWin(job, "CONTAINER_LIST", params, this);
        }
        return params
      }
    }
  }
}
</script>

<style scoped lang='scss'>
#app .main-content .section ::v-deep {
  .data-red {
    input.el-input__inner {
      color: #FF0000;
    }
  }
  .data-blue {
    input.el-input__inner {
      color: #0000ff;
    }
  }
}
</style>
